<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <new-client @add="addClientSidebar" :isSidebarActive="showNewClientSidebar"
                @closeSidebar="showNewClientSidebar = false"/>

    <new-product @add="addProductSidebar" :isSidebarActive="showNewProductSidebar"
                 @closeSidebar="showNewProductSidebar = false"/>

    <search :products="products" @add="addProductSidebar" :isSidebarActive="showSearchProductsSidebar"
            @closeSidebar="showSearchProductsSidebar = false"/>

    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Nuevo comprobante sin cotización</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Client -->
        <div>
          <label class="text-sm opacity-75">Cliente*</label>
          <v-select :options="clients"
                    @input="getClientData"
                    :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="document.client" class="mb-4 md:mb-0" name="client" id="client"
                    v-validate="'notEmptyObject'">
            <template #list-header>
              <li @click="showNewClientSidebar = true"
                  class="add-new-client-header d-flex align-items-center my-50"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="16"
                />
                <span class="align-middle ml-25">
                  Nuevo cliente
                </span>
              </li>
            </template>
          </v-select>
          <span class="text-danger text-sm"
                v-show="errors.has('client')">{{ errors.first('client') }}</span>
        </div>
        <!--End-->

        <!--Message-->
        <div class="mt-5" v-if="document.client.retainer === 'true'">
          <span class="bg-danger min-w-full border text-white block p-2 text-center">Cliente es retenedor</span>
        </div>
        <!--End-->

        <!--Divider-->
        <vs-divider class="mt-5"></vs-divider>

        <!---IGV, Regime and email-->
        <div class="vx-row mt-5">
          <div class="vx-col w-1/4">
            <div>
              <label class="text-sm opacity-75">Tipo de redondeo*</label>
              <v-select @input="calculateTotal" :options="roundingTypes"
                        label="code"
                        :clearable="false"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="document.roundingType" class="mb-4 md:mb-0" name="roundingType" id="roundingType"
                        v-validate="'required'"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('roundingType')">{{ errors.first('roundingType') }}</span>
            </div>
          </div>
          <div class="vx-col w-1/4">
            <label class="text-sm opacity-75">Tipo de regimen*</label>
            <v-select :options="regimeTypes"
                      placeholder="Selecciona"
                      :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="document.regimeType" class="mb-4 md:mb-0" name="regimeType" id="regimeType"
                      v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('regimeType')">{{ errors.first('regimeType') }}</span>
          </div>
          <div class="vx-col w-1/4">
            <div>
              <vs-input class="w-full" label="Email" v-model="document.client.email"/>
            </div>
          </div>
          <div class="vx-col w-1/4">
            <div>
              <label class="text-sm opacity-75">Moneda*</label>
              <v-select :options="currencies"
                        label="value"
                        :clearable="false"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="document.currency" class="mb-4 md:mb-0" name="currency" id="currency"
                        v-validate="'required'"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('currency')">{{ errors.first('currency') }}</span>
            </div>
          </div>
        </div>
        <!--End-->

        <!--Divider-->
        <vs-divider class="mt-5"></vs-divider>

        <!--Observation-->
        <div class="mt-5">
          <vs-textarea v-validate="'max:255'" rows="2" name="observation" label="Observación"
                       v-model="document.observation"/>
          <span class="text-danger text-sm"
                v-show="errors.has('observation')">{{ errors.first('observation') }}</span>
        </div>
        <!--End-->

        <!--Payment type-->
        <div>
          <ul class="demo-alignment">
            <li>
              <vs-radio v-model="document.paymentType" vs-name="paymentType" vs-value="regular">Regular</vs-radio>
            </li>
            <li>
              <vs-radio v-model="document.paymentType" vs-name="paymentType" vs-value="fees">Cuotas</vs-radio>
            </li>
          </ul>
        </div>
        <!--End-->

        <!--Payment method-->
        <template v-if="document.paymentType === 'regular'">
          <div class="vx-row mt-5">
            <div class="vx-col w-1/2">
              <label class="text-sm opacity-75">Forma de pago*</label>
              <v-select :options="paymentMethods"
                        label="value"
                        :clearable="false"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="document.paymentMethod" class="mb-4 md:mb-0" name="paymentMethod" id="paymentMethod"
                        v-validate="'required'"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('paymentMethod')">{{ errors.first('paymentMethod') }}</span>
            </div>
          </div>
        </template>
        <!--End-->

        <!--Fees and frequency-->
        <div v-else-if="document.paymentType === 'fees'" class="vx-row mt-5">
          <div class="vx-col w-1/2">
            <div>
              <label class="text-sm opacity-75">Cuotas*</label>
              <v-select :options="amountOfFees"
                        label="value"
                        :clearable="false"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="document.fees"
                        class="mb-4 md:mb-0"
                        name="fees"
                        id="fees"
                        v-validate="'required'"/>
              <span class="text-danger text-sm"
                    v-show="errors.has('fees')">{{ errors.first('fees') }}</span>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <label class="text-sm opacity-75">Frecuencia*</label>
            <v-select :options="frequencies"
                      label="value"
                      :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="document.frequency" class="mb-4 md:mb-0"
                      v-validate="'required'"
                      name="frequency"
                      id="frequency"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('frequency')">{{ errors.first('frequency') }}</span>
          </div>
        </div>
        <!--End-->

        <!--Divider-->
        <vs-divider class="mt-5"></vs-divider>

        <!--Products-->
        <div class="vx-row mt-5">
          <div class="vx-col w-1/2">
            <vs-button @click="showSearchProductsSidebar = true" :disabled="progress" class="w-full" color="danger"
                       type="filled">
              Buscar producto
            </vs-button>
          </div>
          <div class="vs-col w-1/2">
            <vs-button @click="showNewProductSidebar = true" :disabled="progress" class="w-full" color="danger"
                       type="border">
              Crear producto
            </vs-button>
          </div>
        </div>
        <!--End-->

        <!--Added products-->
        <vs-table class="mt-8" :data="addedProducts">

          <template slot="thead">
            <vs-th>Descripción</vs-th>
            <vs-th>Nro. de Parte</vs-th>
            <vs-th>Precio ({{ document.currency ? document.currency.symbol : '' }})</vs-th>
            <vs-th>Cantidad</vs-th>
            <vs-th>Eliminar</vs-th>
          </template>
          <template slot-scope=" {data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td style="  width: 40%" :data="tr.description">
                <vs-textarea rows="5" v-model="tr.description"></vs-textarea>
              </vs-td>

              <vs-td :data="tr.numberPart">
                <p>{{ tr.numberPart }}</p>
              </vs-td>

              <vs-td :data="tr.price">
                <template>
                  <vs-input min="1" style="  width: 95px" type="number" v-model.number="tr.price"/>
                </template>
              </vs-td>

              <vs-td :data="tr.quantity">
                <template>
                  <vs-input style="  width: 60px" min="1" type="number" v-model.number="tr.quantity"/>
                </template>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon class="ml-2" icon="TrashIcon"
                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              @click.stop="deleteProduct(tr)"/>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
        <!--End-->

        <!--Divider-->
        <vs-divider class="mt-5"></vs-divider>

        <div class="vx-row">
          <div class="vx-col w-3/4"></div>
          <div class="vx-col w-1/4">
            <div class="flex flex-wrap items-center justify-between">
              <span class="font-bold">Sub total:</span>
              <span>
                {{
                Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: this.document.currency.code,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                }).format(total / 1.18)
                }}
              </span>
            </div>
            <!--Divider-->
            <vs-divider class="mt-5"></vs-divider>
            <div class="flex flex-wrap items-center justify-between">
              <span class="font-bold">IGV:</span>
              <span>
                {{
                Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: this.document.currency.code,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                }).format((total / 1.18) * 0.18)
                }}
              </span>
            </div>
            <!--Divider-->
            <vs-divider class="mt-5"></vs-divider>
            <div class="flex flex-wrap items-center justify-between">
              <span class="font-bold">Total:</span>
              <span>
                {{
                Intl.NumberFormat('en', {
                style: 'currency',
                currency: this.document.currency.code,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                }).format(total)
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Generar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="  margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import vSelect from 'vue-select'
import NewClient from '@/views/clients/New'
import NewProduct from '@/views/products/New'
import Search from '@/views/sales/SearchProducts'

import departments from '../../data/ubigeo/departments.json'
import provinces from '../../data/ubigeo/province.json'
import districts from '../../data/ubigeo/district.json'
import ubigeo from '../../data/ubigeo/ubigeo.json'

import { auth, db, FieldValue } from '@/firebase/firebaseConfig'
import axios from 'axios'

export default {
  name: 'NewSaleWQ',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    clients: {
      type: Array,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    NewClient,
    NewProduct,
    Search
  },
  mixins: [trimString],
  data() {
    return {
      document: {
        currency: {
          id: 2,
          value: 'Dólares américanos',
          symbol: '$',
          code: 'USD'
        },
        paymentMethod: {
          id: 30,
          value: 'Crédito a 30 días'
        },
        igvType: 'Incluye IGV',
        roundingType: 4,
        delivery: 'Donde indique dentro de lima metropolitana',
        contact: {},
        address: {},
        offerValidity: '3 días',
        client: {},
        paymentType: 'regular',
        fees: null,
        frequency: null
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      addresses: [],
      contacts: [],
      currencies: [
        {
          id: 1,
          value: 'Soles',
          symbol: 'S/',
          code: 'PEN'
        },
        {
          id: 2,
          value: 'Dólares américanos',
          symbol: '$',
          code: 'USD'
        }
      ],
      paymentMethods: [
        {
          id: 7,
          value: 'Crédito a 7 días'
        },
        {
          id: 30,
          value: 'Crédito a 30 días'
        },
        {
          id: 15,
          value: 'Crédito a 15 días'
        },
        {
          id: 20,
          value: 'Crédito a 20 días'
        },
        {
          id: 45,
          value: 'Crédito a 45 días'
        },
        {
          id: 60,
          value: 'Crédito a 60 días'
        },
        {
          id: 90,
          value: 'Crédito a 90 días'
        },
        {
          id: 1,
          value: '50% Adelantado 50% contra entrega'
        },
        {
          id: 30,
          value: '50% Adelantado 50% a 30 dias'
        },
        {
          id: 0,
          value: 'Contado'
        }
      ],
      igvTypes: [
        'No incluye IGV',
        'Incluye IGV'
      ],
      roundingTypes: [
        4,
        5,
        6
      ],
      regimeTypes: [
        {
          label: 'Sin regimen',
          percentage: 0
        },
        {
          label: 'Retención',
          percentage: 3
        },
        {
          label: 'Detracción (10%)',
          percentage: 10
        },
        {
          label: 'Detracción servicios (12%)',
          percentage: 12
        }
      ],
      // Sidebars
      showNewClientSidebar: false,
      showAddressSidebar: false,
      showContactSidebar: false,
      showNewProductSidebar: false,
      showSearchProductsSidebar: false,
      // End

      // Fees
      amountOfFees: [
        {
          id: 2,
          value: '2 Cuotas'
        },
        {
          id: 3,
          value: '3 Cuotas'
        },
        {
          id: 4,
          value: '4 Cuotas'
        }
      ],
      frequencies: [
        {
          id: 15,
          value: 'Cada 15 días'
        },
        {
          id: 30,
          value: 'Cada 30 días'
        }
      ],
      // End

      // Ubigeo
      departments: departments,
      provinces: provinces,
      districts: districts,
      ubigeo: ubigeo,
      addedProducts: [],
      selected: null,
      total: 0
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.addedProducts = []
        this.document = {
          currency: {
            id: 2,
            value: 'Dólares américanos',
            symbol: '$',
            code: 'USD'
          },
          paymentMethod: {
            id: 30,
            value: 'Crédito a 30 días'
          },
          igvType: 'Incluye IGV',
          roundingType: 4,
          client: {},
          paymentType: 'regular',
          fees: null,
          frequency: null
        }
        this.$validator.reset()
      }
    },
    addedProducts: {
      deep: true,
      handler() {
        this.calculateTotal()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    /**
     * Save data in firestore
     * @returns {Promise<void>}
     */
    async submitData() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          if (this.total !== 0) {
            this.progress = true
            // Calculate total
            const total = this.total
            const subTotal = parseFloat((this.total / 1.18).toFixed(2))
            const igv = parseFloat((total - subTotal).toFixed(2))
            // Get sequence
            let code = ''
            let sequence = ''
            let serie = ''
            if (this.document.client.typeDocument === 'RUC') {
              const response = await axios.get('https://southamerica-east1-anglidata-1aa70.cloudfunctions.net/sequences-getSequencesForInvoices', {
                headers: {
                  'Authorization': 'Bearer bd14b377-92f6-4741-8303-1f372131897c'
                }
              })
              code = 'FFF1-' + response.data.sequence
              sequence = response.data.sequence
              serie = 'FFF1'
            } else {
              const response = await axios.get('https://southamerica-east1-anglidata-1aa70.cloudfunctions.net/sequences-getSequencesForTickets', {
                headers: {
                  'Authorization': 'Bearer bd14b377-92f6-4741-8303-1f372131897c'
                }
              })
              code = 'BBB1-' + response.data.sequence
              sequence = response.data.sequence
              serie = 'BBB1'
            }
            // End
            // Get exchange rate
            const responseExchange = await axios.get('https://southamerica-east1-anglidata-1aa70.cloudfunctions.net/exchangeRate-getExchangeRate', {
              headers: {
                'Authorization': 'Bearer 78b1deb4-1b27-4943-9d83-818285cc59d6'
              }
            })
            // End
            let obj = {
              ...this.document,
              state: true,
              status: 'hold',
              products: [
                ...this.addedProducts
              ],
              total,
              subTotal,
              igv,
              user: {
                displayName: auth.currentUser.displayName,
                uid: auth.currentUser.uid
              },
              code,
              type: 'wq',
              sequence,
              serie,
              paidOut: 0,
              dueDate: new Date(new Date().setDate(new Date().getDate() + this.document.paymentMethod.id)),
              exchangeRate: responseExchange.data.venta
            }
            // Filter Products
            obj.filterProducts = []
            obj.products.forEach((p) => {
              obj.filterProducts.push(p.numberPart)
            })
            // End
            // Save in firestore
            const doc = await db.collection('sales').add({
              ...obj,
              createdAt: FieldValue.serverTimestamp()
            })
            obj.id = doc.id
            obj.createdAt = new Date()

            // Send to nubefact
            const responseNubefact = await this.sendNubefact(sequence, total, subTotal, igv, serie, responseExchange.data.venta)
            if (responseNubefact !== -1) {
              await db.collection('sales').doc(doc.id).update({
                nubefact: {
                  ...responseNubefact.nubefact
                },
                status: responseNubefact.nubefact.aceptada_por_sunat ? 'send' : 'not_send'
              })
              // Open PDF in browser
              window.open(responseNubefact.nubefact.enlace_del_pdf, 'blank')
              obj.status = responseNubefact.nubefact.aceptada_por_sunat ? 'send' : 'not_send'
            }
            obj.nubefact = {
              ...responseNubefact.nubefact
            }
            // End
            this.$emit('add', obj)
            this.$emit('closeSidebar')
            this.$vs.notify({
              color: 'success',
              title: 'Comprobante de venta',
              text: 'Comprobante creado correctamente.'
            })
          } else {
            this.$vs.notify({
              color: 'warning',
              title: 'Comprobante de venta',
              text: 'Revisa cantidad y precio de productos.'
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error'
        })
      } finally {
        this.progress = false
      }
    },
    /**
     * Send nubefact
     */
    async sendNubefact(sequence, total, subTotal, igv, serie, exchangeRate) {
      try {
        const items = []
        this.addedProducts.forEach((p) => {
          items.push(
            {
              'unidad_de_medida': 'NIU',
              'codigo': p.numberPart,
              'codigo_producto_sunat': '32130000',
              'descripcion': p.description,
              'cantidad': p.quantity,
              'valor_unitario': p.price,
              'precio_unitario': parseFloat((p.price * 1.18).toFixed(this.document.roundingType)),
              'descuento': '',
              'subtotal': parseFloat((p.price * p.quantity).toFixed(this.document.roundingType)),
              'tipo_de_igv': 1,
              'igv': parseFloat((p.price * p.quantity * 1.18).toFixed(this.document.roundingType)) - parseFloat((p.price * p.quantity).toFixed(this.document.roundingType)),
              'total': parseFloat((p.price * p.quantity * 1.18).toFixed(this.document.roundingType)),
              'anticipo_regularizacion': false,
              'anticipo_documento_serie': '',
              'anticipo_documento_numero': ''
            }
          )
        })
        // Split emails
        const clientDoc = await db.collection('clients').doc(this.document.client.id).get()
        const emails = clientDoc.data().email !== '_' ? clientDoc.data().email.split(',') : []
        // End
        const document = {
          'operacion': 'generar_comprobante',
          'tipo_de_comprobante': this.document.client.typeDocument === 'RUC' ? 1 : 2,
          'serie': serie,
          'numero': sequence,
          'sunat_transaction': 1,
          'cliente_tipo_de_documento': this.document.client.typeDocument === 'RUC' ? '6' : '1',
          'cliente_numero_de_documento': this.document.client.document + '',
          'cliente_denominacion': this.document.client.businessName,
          'cliente_direccion': this.document.client.address + '-' + this.document.client.department + '-' + this.document.client.province + '-' + this.document.client.district,
          'fecha_de_emision': new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear(),
          'moneda': this.document.currency.id,
          'porcentaje_de_igv': 18,
          'total_gravada': subTotal,
          'total_igv': igv,
          'total': total,
          'observaciones': this.document.observation,
          'enviar_automaticamente_a_la_sunat': true,
          'enviar_automaticamente_al_cliente': true,
          'formato_de_pdf': '',
          'medio_de_pago': this.document.paymentMethod.id !== 0 || this.document.paymentType !== 'regular' ? 'CRÉDITO' : 'CONTADO',
          'condiciones_de_pago': this.document.paymentMethod.value.toUpperCase(),
          'tipo_de_cambio': exchangeRate,
          'cliente_email': emails.length >= 1 ? emails[0].trim() : '',
          'cliente_email_1': emails.length >= 2 ? emails[1].trim() : '',
          'cliente_email_2': emails.length >= 3 ? emails[2].trim() : ''
        }

        // Bills
        if (this.document.paymentType === 'regular') {
          if (this.document.paymentMethod.id !== 0) {
            let billTotal = 0
            if (this.document.regimeType.percentage === 0) {
              billTotal = total
            }
            else {
              billTotal = total - (total * this.document.regimeType.percentage / 100)
            }
            let dueDate = new Date(new Date().setDate(new Date().getDate() + this.document.paymentMethod.id))
            document.venta_al_credito = [{
              cuota: '1',
              importe: billTotal,
              fecha_de_pago: dueDate.getDate() + '-' + (dueDate.getMonth() + 1) + '-' + dueDate.getFullYear()
            }]
            document.fecha_de_vencimiento = dueDate.getDate() + '-' + (dueDate.getMonth() + 1) + '-' + dueDate.getFullYear()
          }
          else {
            let dueDate = new Date(new Date().setDate(new Date().getDate() + 1))
            document.fecha_de_vencimiento = dueDate.getDate() + '-' + (dueDate.getMonth() + 1) + '-' + dueDate.getFullYear()
          }
        }
        else {
          let billTotal = 0
          if (this.document.regimeType.percentage === 0) {
            billTotal = total
          }
          else {
            billTotal = total - (total * this.document.regimeType.percentage / 100)
          }
          document.venta_al_credito = []
          let dueDate = null
          for (let i = 1; i <= this.document.fees.id; i++) {
            dueDate = new Date(new Date().setDate(new Date().getDate() + (this.document.frequency.id * i)))
            document.venta_al_credito.push({
              cuota: i + '',
              importe: this.toFixedFloor(billTotal / this.document.fees.id, 2),
              fecha_de_pago: dueDate.getDate() + '-' + (dueDate.getMonth() + 1) + '-' + dueDate.getFullYear()
            })
          }
          document.fecha_de_vencimiento = dueDate.getDate() + '-' + (dueDate.getMonth() + 1) + '-' + dueDate.getFullYear()
        }
        // End


        // Regime
        if (this.document.regimeType.percentage !== 0) {
          if (this.document.regimeType.percentage === 3) {
            document.retencion_tipo = 1
            document.retencion_base_imponible = total
            document.total_retencion = parseFloat((total * 3 / 100).toFixed(2))
          }
          else if (this.document.regimeType.percentage === 12 || this.document.regimeType.percentage === 10) {
            document.sunat_transaction = 30
            document.detraccion = true
            document.detraccion_tipo = 35
            document.detraccion_total = this.document.currency.id === 1 ? (total * (this.document.regimeType.percentage / 100)) : ((total * (this.document.regimeType.percentage / 100)) * exchangeRate)
            document.detraccion_porcentaje = this.document.regimeType.percentage
            document.medio_de_pago_detraccion = 1
          }
        }
        const response = await this.$http.post('https://southamerica-east1-anglidata-1aa70.cloudfunctions.net/nubefact-sendInvoices', {
            document,
            items
          }, {
            headers: {
              'Authorization': 'Bearer bd14b377-92f6-4741-8303-1f372131897c'
            }
          })
        return response.data
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: e.response.data.errors,
          time: 7000
        })
        return -1
      }
    },
    /**
     * Client Sidebar
     */
    addClientSidebar(o) {
      this.clients.unshift({
        id: o.id,
        document: o.document,
        typeDocument: o.typeDocument,
        businessName: o.businessName,
        email: o.email,
        label: o.businessName + ' - ' + o.document,
        address: o.address,
        department: o.department,
        province: o.province,
        district: o.district,
        ubigeo: o.ubigeo
      })
    },
    /**
     * Search product sidebar
     */
    addProductSidebar(o) {
      let obj = {
        id: o.id,
        description: o.description,
        sku: o.id.substr(0, 6),
        numberPart: o.numberPart,
        deliveryTerm: 7,
        warranty: 12,
        price: 0,
        quantity: 1,
        guide: 0,
        invoice: 0,
        purchaseOrder: 0
      }
      this.addedProducts.push(obj)
      this.showSearchProductsSidebar = false
    },
    /**
     * Delete product
     */
    deleteProduct(product) {
      const indexProduct = this.addedProducts.findIndex((p) => p.id === product.id)
      this.addedProducts.splice(indexProduct, 1)
    },
    /**
     * Calculate total
     */
    calculateTotal() {
      this.total = 0
      this.addedProducts.forEach((p) => {
        if (this.document.igvType === 'No incluye IGV') {
          this.total += parseFloat((p.quantity * p.price * 1.18).toFixed(2))
        } else {
          this.total += parseFloat((p.quantity * p.price * 1.18).toFixed(2))
        }
      })
      this.total = parseFloat(this.total.toFixed(2))
    },
    /**
     * Get client data
     */
    async getClientData() {
      if (this.document.client.paymentMethod) {
        this.document.paymentMethod = this.document.client.paymentMethod
      }
      else {
        this.document.paymentMethod = {
          id: 30,
          value: 'Crédito a 30 días'
        }
      }
      await this.validateRetentionAgents()
    },
    /**
     *
     * @param num
     * @param decimalPlaces
     * @returns {number}
     */
    toFixedFloor(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces);
      return Math.floor(num * factor) / factor;
    },
    /**
     * Validate retention agents
     * @returns {Promise<void>}
     */
    async validateRetentionAgents() {
      try {
        const response = await this.$http.get('https://southamerica-east1-anglidata-1aa70.cloudfunctions.net/vendor-validateRetentionAgents?document=' + this.document.client.document, {
          headers: {
            Authorization: 'Bearer bd14b377-92f6-4741-8303-1f372131897c'
          }
        })

        if (response.data.es_agente_retencion) {
          this.document.client.retainer = 'true'
        }
        else {
          this.document.client.retainer = 'false'
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.add-new-client-header {
  padding: 8px;
  color: green;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    height: 15px;
    margin-right: 4px;
  }

  &:hover {
    background-color: rgba(green, 0.12);
  }
}

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 80vw;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
